import { Button } from '@smuchile/pkg-unimarc-components'
import {
  getBemId,
  getGlobalStyle
} from '@smuchile/pkg-unimarc-components/helpers'
import styles from '../../Body/Body.module.css'

interface ModalButtonProps {
  isLoadingOrderForm: boolean
  minWidth?: string
  handleOnClick: () => void
}

export const ModalButton = ({
  isLoadingOrderForm,
  minWidth,
  handleOnClick
}: ModalButtonProps): React.ReactElement => {
  return (
    <Button
      borderRadius={getGlobalStyle('--border-radius-xl')}
      customClassName={styles.focusBtn__mobile}
      fontSize='lg'
      fontWeight={getGlobalStyle('--font-weight-medium')}
      id={getBemId('myUsualsAndFavoritesModal', 'button')}
      isLoading={isLoadingOrderForm}
      label='Continuar'
      minWidth={minWidth}
      onClick={handleOnClick}
      pointLoaderBigger={true}
      size='lg'
      type='primary-gray'
    />
  )
}
